import { useCallback, useRef } from 'react'

import { useCustomerProductTourStatus } from 'hooks/useCustomerProductTourStatus'
import { ProductTourStatus } from 'hooks/useCustomerQuery/graphql/getCustomer.types'
import { useLoggedInUser } from 'hooks/useLoggedInUser'

export const useProductLaunchModalCMS = (
  statusName?: keyof ProductTourStatus
) => {
  const { userData } = useLoggedInUser()
  const { updateProductTourStatus } = useCustomerProductTourStatus()

  const hasNotSeenBefore = useRef(
    statusName ? userData?.productTourStatus?.[statusName] : true
  )
  const shouldShowModal = Boolean(hasNotSeenBefore.current)

  const disableModal = useCallback(async () => {
    if (statusName) {
      await updateProductTourStatus({ [statusName]: false })
    }
  }, [statusName, updateProductTourStatus])

  return {
    shouldShowModal,
    disableModal,
  }
}
